import { useContext, useEffect } from "react";
import Container from "../../components/commons/Container";
import classes from "../../scss/Privacy.module.scss";
import { GlobalContext } from "../../context/global/globalContext";
import { pagesIds } from "../../constants/api";
import { decodeEntities } from "@wordpress/html-entities";

export default function PrivacyPolicy() {
  const { getCurrentPage, getPage } = useContext(GlobalContext);

  const page = getCurrentPage(pagesIds.policy);

  useEffect(() => getPage(pagesIds.contactUs), []);

  if (!page) {
    return null;
  }

  return (
    <section className={classes.privacy}>
      <Container>
        <article
          dangerouslySetInnerHTML={{
            __html: decodeEntities(page.content.rendered),
          }}
        />
      </Container>
    </section>
  );
}
